import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
    addUserMultiple,
} from '~Betslip/slices/userMultiplesSlice';

import {
    selectCanAddMultiple,
    selectAvailableMultiples,
} from '~Betslip/selectors/userMultiplesSelectors';

const AddBet = () => {
    const [ t ] = useTranslation();
    const dispatch = useDispatch();

    const canAddMultiple = useSelector(selectCanAddMultiple);
    const availableMultiples = useSelector(selectAvailableMultiples);

    if (!canAddMultiple) {
        return null;
    }

    const onClickAddBet = () => {
        const [{ id: betTypeId }] = availableMultiples;
        dispatch(addUserMultiple(betTypeId));
    };

    return (
        <div
            className="fullslip__add-multiple"
            onClick={onClickAddBet}
        >
            <span className="fullslip__add-multiple-icon">
                <i className="fullslip__add-icon"></i>
            </span>
            <span className="fullslip__add-multiple-label">{t('betslip.add_bet')}</span>
            <span className="fullslip__add-multiple-info">{t('betslip.max_bets')}</span>
        </div>
    );
};

export default AddBet;
